"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[791],{

/***/ 99064:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = undefined;

var _classCallCheck2 = __webpack_require__(99663);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22600);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(49135);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(93196);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  container: {
    backgroundColor: '#eee',
    color: '#FF3B30',
    padding: 20,
    fontFamily: 'monospace',
    fontSize: 16
  },
  title: {
    fontSize: 18,
    marginBottom: 10,
    color: 'black',
    fontWeight: 700
  }
};

var Error = function (_React$Component) {
  (0, _inherits3.default)(Error, _React$Component);

  function Error() {
    (0, _classCallCheck3.default)(this, Error);
    return (0, _possibleConstructorReturn3.default)(this, (Error.__proto__ || Object.getPrototypeOf(Error)).apply(this, arguments));
  }

  (0, _createClass3.default)(Error, [{
    key: 'renderGraphQL',
    value: function renderGraphQL() {
      return _react2.default.createElement(
        'div',
        { style: styles.container },
        _react2.default.createElement(
          'div',
          { style: styles.title },
          'GraphQL Error:'
        ),
        this.props.error.graphQLErrors.map(function (error, index) {
          return _react2.default.createElement(
            'div',
            { key: index },
            error.message
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.error.graphQLErrors) {
        return this.renderGraphQL();
      }
      return _react2.default.createElement(
        'div',
        { style: styles.container },
        _react2.default.createElement(
          'div',
          { style: styles.title },
          'Error:'
        ),
        String(this.props.error)
      );
    }
  }]);
  return Error;
}(_react2.default.Component);

Error.propTypes = {
  error: _propTypes2.default.object
};
exports["default"] = Error;

/***/ }),

/***/ 86301:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = undefined;

var _classCallCheck2 = __webpack_require__(99663);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22600);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(49135);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(93196);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function (_React$Component) {
  (0, _inherits3.default)(Loading, _React$Component);

  function Loading() {
    (0, _classCallCheck3.default)(this, Loading);
    return (0, _possibleConstructorReturn3.default)(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).apply(this, arguments));
  }

  (0, _createClass3.default)(Loading, [{
    key: 'getStyles',
    value: function getStyles() {
      return {
        height: this.props.height,
        backgroundColor: '#EEEEEE',
        borderRadius: 3
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { style: this.getStyles() });
    }
  }]);
  return Loading;
}(_react2.default.Component);

Loading.propTypes = {
  height: _propTypes2.default.number
};
Loading.defaultProps = {
  height: 200
};
exports["default"] = Loading;

/***/ }),

/***/ 25929:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = undefined;

var _classCallCheck2 = __webpack_require__(99663);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22600);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(49135);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(93196);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  container: {
    backgroundColor: '#eee',
    color: '#FF3B30',
    padding: 20,
    fontFamily: 'monospace',
    fontSize: 16
  },
  title: {
    fontSize: 18,
    marginBottom: 10,
    color: 'black',
    fontWeight: 700
  }
};

var Error = function (_React$Component) {
  (0, _inherits3.default)(Error, _React$Component);

  function Error() {
    (0, _classCallCheck3.default)(this, Error);
    return (0, _possibleConstructorReturn3.default)(this, (Error.__proto__ || Object.getPrototypeOf(Error)).apply(this, arguments));
  }

  (0, _createClass3.default)(Error, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: styles.container },
        _react2.default.createElement(
          'div',
          { style: styles.title },
          'Connection Error'
        ),
        'Trying to reconnect...'
      );
    }
  }]);
  return Error;
}(_react2.default.Component);

Error.propTypes = {
  error: _propTypes2.default.object
};
exports["default"] = Error;

/***/ }),

/***/ 23026:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));

exports["default"] = function (query, options, props) {
  var operationVariables = query.definitions[0].variableDefinitions || [];
  var variables = {};

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = operationVariables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var operationVariable = _step.value;
      var variable = operationVariable.variable,
          type = operationVariable.type;

      if (!variable.name || !variable.name.value) continue;

      if (typeof props[variable.name.value] !== 'undefined') {
        variables[variable.name.value] = props[variable.name.value];
        continue;
      }

      if (props.params && typeof props.params[variable.name.value] !== 'undefined') {
        variables[variable.name.value] = props.params[variable.name.value];
        continue;
      }

      if (props.match && props.match.params && typeof props.match.params[variable.name.value] !== 'undefined') {
        variables[variable.name.value] = props.match.params[variable.name.value];
        continue;
      }

      if (props.navigation && props.navigation.state && props.navigation.state.params && typeof props.navigation.state.params[variable.name.value] !== 'undefined') {
        variables[variable.name.value] = props.navigation.state.params[variable.name.value];
        continue;
      }

      // allow optional props
      if (type.kind !== 'NonNullType') {
        variables[variable.name.value] = null;
        continue;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return variables;
};

/***/ }),

/***/ 70791:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _classCallCheck2 = __webpack_require__(99663);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22600);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(49135);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(93196);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(88239);

var _extends3 = _interopRequireDefault(_extends2);

exports["default"] = function (query) {
  var userConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (ComposedComponent) {
    var defaultConfig = {
      loading: _react2.default.createElement(_Loading2.default, null),
      errorComponent: _Error2.default,
      tryRefetch: 0
    };

    var config = (0, _extends3.default)({}, defaultConfig, userConfig);

    var GraphQLQuery = function (_React$Component) {
      (0, _inherits3.default)(GraphQLQuery, _React$Component);

      function GraphQLQuery() {
        (0, _classCallCheck3.default)(this, GraphQLQuery);
        return (0, _possibleConstructorReturn3.default)(this, (GraphQLQuery.__proto__ || Object.getPrototypeOf(GraphQLQuery)).apply(this, arguments));
      }

      (0, _createClass3.default)(GraphQLQuery, [{
        key: 'hasData',
        value: function hasData() {
          return Object.keys(this.props._data).length > 10;
        }
      }, {
        key: 'renderLoading',
        value: function renderLoading() {
          if (!config.loading) return this.renderComposed();
          if (userConfig.loading) return config.loading;
          // eslint-disable-next-line
          return __webpack_require__.g.apolloLoadingComponent ? _react2.default.createElement(__webpack_require__.g.apolloLoadingComponent, null) : config.loading;
        }
      }, {
        key: 'renderNetworkError',
        value: function renderNetworkError() {
          if (this.hasData()) return this.renderComposed();
          if (!__webpack_require__.g.apolloNetworkErrorComponent && config.loading) return this.renderLoading();
          var GlobalComponent = __webpack_require__.g.apolloNetworkErrorComponent;
          var ConfigComponent = userConfig.networkErrorComponent;
          if (ConfigComponent !== null) {
            if (ConfigComponent) return _react2.default.createElement(ConfigComponent, null);
            return GlobalComponent ? _react2.default.createElement(GlobalComponent, null) : _react2.default.createElement(_NetworkError2.default, null);
          }
          return this.renderComposed();
        }
      }, {
        key: 'renderError',
        value: function renderError(error) {
          error = error || this.props.error;
          if (error.networkError) return this.renderNetworkError();
          return __webpack_require__.g.apolloErrorComponent ?
          // eslint-disable-next-line
          _react2.default.createElement(__webpack_require__.g.apolloErrorComponent, { error: error }) : _react2.default.createElement(_Error2.default, { error: error });
        }
      }, {
        key: 'renderComposed',
        value: function renderComposed() {
          try {
            return _react2.default.createElement(ComposedComponent, this.props);
          } catch (error) {
            return this.renderError(error);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              networkStatus = _props.networkStatus,
              error = _props.error;

          if (networkStatus === 1) {
            return this.renderLoading();
          }

          if (networkStatus < 7 && !this.hasData()) {
            return this.renderLoading();
          }

          if (error) {
            return this.renderError();
          }

          return this.renderComposed();
        }
      }]);
      return GraphQLQuery;
    }(_react2.default.Component);

    var WithGraphQL = (0, _hoc.graphql)(query, (0, _extends3.default)({}, config, {
      props: function props(_ref) {
        var ownProps = _ref.ownProps,
            data = _ref.data;

        return (0, _extends3.default)({
          _data: data
        }, ownProps, data);
      },
      options: function options(props) {
        var options = config.options;
        var userOptions = (typeof options === 'function' ? options(props) : options) || {};
        if (userOptions.pollInterval && !userOptions.fetchPolicy) {
          userOptions.fetchPolicy = 'network-only';
        }
        return (0, _extends3.default)({
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'cache-and-network' }, userOptions, {
          variables: (0, _extends3.default)({}, (0, _getVariables2.default)(query, config, props), userOptions.variables || {})
        });
      }
    }))(GraphQLQuery);

    WithGraphQL.propTypes = ComposedComponent.propTypes;
    WithGraphQL.defaultProps = ComposedComponent.defaultProps;
    WithGraphQL.navigationOptions = ComposedComponent.navigationOptions;

    return WithGraphQL;
  };
};

var _hoc = __webpack_require__(63237);

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _Loading = __webpack_require__(86301);

var _Loading2 = _interopRequireDefault(_Loading);

var _Error = __webpack_require__(99064);

var _Error2 = _interopRequireDefault(_Error);

var _getVariables = __webpack_require__(23026);

var _getVariables2 = _interopRequireDefault(_getVariables);

var _NetworkError = __webpack_require__(25929);

var _NetworkError2 = _interopRequireDefault(_NetworkError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 63659:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var _hooks_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50319);


function Mutation(props) {
    var _a = (0,_hooks_index_js__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .D)(props.mutation, props), runMutation = _a[0], result = _a[1];
    return props.children ? props.children(runMutation, result) : null;
}
Mutation.propTypes = {
    mutation: prop_types__WEBPACK_IMPORTED_MODULE_1__.object.isRequired,
    variables: prop_types__WEBPACK_IMPORTED_MODULE_1__.object,
    optimisticResponse: prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1__.object, prop_types__WEBPACK_IMPORTED_MODULE_1__.func]),
    refetchQueries: prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_1__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1__.string, prop_types__WEBPACK_IMPORTED_MODULE_1__.object])),
        prop_types__WEBPACK_IMPORTED_MODULE_1__.func
    ]),
    awaitRefetchQueries: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
    update: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
    children: prop_types__WEBPACK_IMPORTED_MODULE_1__.func.isRequired,
    onCompleted: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
    onError: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
    fetchPolicy: prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
};
//# sourceMappingURL=Mutation.js.map

/***/ }),

/***/ 72939:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Query; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23564);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var _hooks_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71641);



function Query(props) {
    var children = props.children, query = props.query, options = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__rest */ ._T)(props, ["children", "query"]);
    var result = (0,_hooks_index_js__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(query, options);
    return result ? children(result) : null;
}
Query.propTypes = {
    client: prop_types__WEBPACK_IMPORTED_MODULE_2__.object,
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.func.isRequired,
    fetchPolicy: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    notifyOnNetworkStatusChange: prop_types__WEBPACK_IMPORTED_MODULE_2__.bool,
    onCompleted: prop_types__WEBPACK_IMPORTED_MODULE_2__.func,
    onError: prop_types__WEBPACK_IMPORTED_MODULE_2__.func,
    pollInterval: prop_types__WEBPACK_IMPORTED_MODULE_2__.number,
    query: prop_types__WEBPACK_IMPORTED_MODULE_2__.object.isRequired,
    variables: prop_types__WEBPACK_IMPORTED_MODULE_2__.object,
    ssr: prop_types__WEBPACK_IMPORTED_MODULE_2__.bool,
    partialRefetch: prop_types__WEBPACK_IMPORTED_MODULE_2__.bool,
    returnPartialData: prop_types__WEBPACK_IMPORTED_MODULE_2__.bool
};
//# sourceMappingURL=Query.js.map

/***/ }),

/***/ 89549:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ Subscription; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var _hooks_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75436);


function Subscription(props) {
    var result = (0,_hooks_index_js__WEBPACK_IMPORTED_MODULE_0__/* .useSubscription */ .m)(props.subscription, props);
    return props.children && result ? props.children(result) : null;
}
Subscription.propTypes = {
    subscription: prop_types__WEBPACK_IMPORTED_MODULE_1__.object.isRequired,
    variables: prop_types__WEBPACK_IMPORTED_MODULE_1__.object,
    children: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
    onSubscriptionData: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
    onSubscriptionComplete: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
    shouldResubscribe: prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1__.func, prop_types__WEBPACK_IMPORTED_MODULE_1__.bool])
};
//# sourceMappingURL=Subscription.js.map

/***/ }),

/***/ 63237:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "graphql": function() { return /* reexport */ graphql; },
  "withApollo": function() { return /* reexport */ withApollo; },
  "withMutation": function() { return /* reexport */ withMutation; },
  "withQuery": function() { return /* reexport */ withQuery; },
  "withSubscription": function() { return /* reexport */ withSubscription; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(65196);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/parser/index.js
var parser = __webpack_require__(14692);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(23564);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/components/Query.js
var Query = __webpack_require__(72939);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hoc/hoc-utils.js



var defaultMapPropsToOptions = function () { return ({}); };
var defaultMapResultToProps = function (props) { return props; };
var defaultMapPropsToSkip = function () { return false; };
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
function calculateVariablesFromProps(operation, props) {
    var variables = {};
    for (var _i = 0, _a = operation.variables; _i < _a.length; _i++) {
        var _b = _a[_i], variable = _b.variable, type = _b.type;
        if (!variable.name || !variable.name.value)
            continue;
        var variableName = variable.name.value;
        var variableProp = props[variableName];
        if (typeof variableProp !== 'undefined') {
            variables[variableName] = variableProp;
            continue;
        }
        if (type.kind !== 'NonNullType') {
            variables[variableName] = undefined;
        }
    }
    return variables;
}
var GraphQLBase = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(GraphQLBase, _super);
    function GraphQLBase(props) {
        var _this = _super.call(this, props) || this;
        _this.withRef = false;
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
        return _this;
    }
    GraphQLBase.prototype.getWrappedInstance = function () {
        __DEV__ ? (0,globals/* invariant */.kG)(this.withRef, "To access the wrapped instance, you need to specify " +
            "{ withRef: true } in the options") : (0,globals/* invariant */.kG)(this.withRef, 27);
        return this.wrappedInstance;
    };
    GraphQLBase.prototype.setWrappedInstance = function (ref) {
        this.wrappedInstance = ref;
    };
    return GraphQLBase;
}(react.Component));

//# sourceMappingURL=hoc-utils.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hoc/query-hoc.js






function withQuery(document, operationOptions) {
    if (operationOptions === void 0) { operationOptions = {}; }
    var operation = (0,parser/* parser */.E2)(document);
    var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c;
    var mapPropsToOptions = options;
    if (typeof mapPropsToOptions !== 'function') {
        mapPropsToOptions = function () { return options; };
    }
    var mapPropsToSkip = skip;
    if (typeof mapPropsToSkip !== 'function') {
        mapPropsToSkip = function () { return skip; };
    }
    var lastResultProps;
    return function (WrappedComponent) {
        var graphQLDisplayName = "".concat(alias, "(").concat(getDisplayName(WrappedComponent), ")");
        var GraphQL = (function (_super) {
            (0,tslib_es6/* __extends */.ZT)(GraphQL, _super);
            function GraphQL() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            GraphQL.prototype.render = function () {
                var _this = this;
                var props = this.props;
                var shouldSkip = mapPropsToSkip(props);
                var opts = shouldSkip
                    ? Object.create(null)
                    : (0,tslib_es6/* __assign */.pi)({}, mapPropsToOptions(props));
                if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                    opts.variables = calculateVariablesFromProps(operation, props);
                }
                return (react.createElement(Query/* Query */.A, (0,tslib_es6/* __assign */.pi)({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, query: document }), function (_a) {
                    var _b, _c;
                    var _ = _a.client, data = _a.data, r = (0,tslib_es6/* __rest */._T)(_a, ["client", "data"]);
                    if (operationOptions.withRef) {
                        _this.withRef = true;
                        props = Object.assign({}, props, {
                            ref: _this.setWrappedInstance
                        });
                    }
                    if (shouldSkip) {
                        return (react.createElement(WrappedComponent, (0,tslib_es6/* __assign */.pi)({}, props, {})));
                    }
                    var result = Object.assign(r, data || {});
                    var name = operationOptions.name || 'data';
                    var childProps = (_b = {}, _b[name] = result, _b);
                    if (operationOptions.props) {
                        var newResult = (_c = {},
                            _c[name] = result,
                            _c.ownProps = props,
                            _c);
                        lastResultProps = operationOptions.props(newResult, lastResultProps);
                        childProps = lastResultProps;
                    }
                    return (react.createElement(WrappedComponent, (0,tslib_es6/* __assign */.pi)({}, props, childProps)));
                }));
            };
            GraphQL.displayName = graphQLDisplayName;
            GraphQL.WrappedComponent = WrappedComponent;
            return GraphQL;
        }(GraphQLBase));
        return hoist_non_react_statics_cjs(GraphQL, WrappedComponent, {});
    };
}
//# sourceMappingURL=query-hoc.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(63659);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hoc/mutation-hoc.js






function withMutation(document, operationOptions) {
    if (operationOptions === void 0) { operationOptions = {}; }
    var operation = (0,parser/* parser */.E2)(document);
    var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.alias, alias = _b === void 0 ? 'Apollo' : _b;
    var mapPropsToOptions = options;
    if (typeof mapPropsToOptions !== 'function')
        mapPropsToOptions = function () { return options; };
    return function (WrappedComponent) {
        var graphQLDisplayName = "".concat(alias, "(").concat(getDisplayName(WrappedComponent), ")");
        var GraphQL = (function (_super) {
            (0,tslib_es6/* __extends */.ZT)(GraphQL, _super);
            function GraphQL() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            GraphQL.prototype.render = function () {
                var props = this.props;
                var opts = mapPropsToOptions(props);
                if (operationOptions.withRef) {
                    this.withRef = true;
                    props = Object.assign({}, props, {
                        ref: this.setWrappedInstance
                    });
                }
                if (!opts.variables && operation.variables.length > 0) {
                    opts.variables = calculateVariablesFromProps(operation, props);
                }
                return (react.createElement(Mutation/* Mutation */.m, (0,tslib_es6/* __assign */.pi)({ ignoreResults: true }, opts, { mutation: document }), function (mutate, _a) {
                    var _b, _c;
                    var data = _a.data, r = (0,tslib_es6/* __rest */._T)(_a, ["data"]);
                    var result = Object.assign(r, data || {});
                    var name = operationOptions.name || 'mutate';
                    var resultName = operationOptions.name
                        ? "".concat(name, "Result")
                        : 'result';
                    var childProps = (_b = {},
                        _b[name] = mutate,
                        _b[resultName] = result,
                        _b);
                    if (operationOptions.props) {
                        var newResult = (_c = {},
                            _c[name] = mutate,
                            _c[resultName] = result,
                            _c.ownProps = props,
                            _c);
                        childProps = operationOptions.props(newResult);
                    }
                    return react.createElement(WrappedComponent, (0,tslib_es6/* __assign */.pi)({}, props, childProps));
                }));
            };
            GraphQL.displayName = graphQLDisplayName;
            GraphQL.WrappedComponent = WrappedComponent;
            return GraphQL;
        }(GraphQLBase));
        return hoist_non_react_statics_cjs(GraphQL, WrappedComponent, {});
    };
}
//# sourceMappingURL=mutation-hoc.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/components/Subscription.js
var Subscription = __webpack_require__(89549);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hoc/subscription-hoc.js






function withSubscription(document, operationOptions) {
    if (operationOptions === void 0) { operationOptions = {}; }
    var operation = (0,parser/* parser */.E2)(document);
    var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c, shouldResubscribe = operationOptions.shouldResubscribe;
    var mapPropsToOptions = options;
    if (typeof mapPropsToOptions !== 'function')
        mapPropsToOptions = function () { return options; };
    var mapPropsToSkip = skip;
    if (typeof mapPropsToSkip !== 'function')
        mapPropsToSkip = function () { return skip; };
    var lastResultProps;
    return function (WrappedComponent) {
        var graphQLDisplayName = "".concat(alias, "(").concat(getDisplayName(WrappedComponent), ")");
        var GraphQL = (function (_super) {
            (0,tslib_es6/* __extends */.ZT)(GraphQL, _super);
            function GraphQL(props) {
                var _this = _super.call(this, props) || this;
                _this.state = { resubscribe: false };
                return _this;
            }
            GraphQL.prototype.updateResubscribe = function (resubscribe) {
                this.setState({ resubscribe: resubscribe });
            };
            GraphQL.prototype.componentDidUpdate = function (prevProps) {
                var resubscribe = !!(shouldResubscribe &&
                    shouldResubscribe(prevProps, this.props));
                if (this.state.resubscribe !== resubscribe) {
                    this.updateResubscribe(resubscribe);
                }
            };
            GraphQL.prototype.render = function () {
                var _this = this;
                var props = this.props;
                var shouldSkip = mapPropsToSkip(props);
                var opts = shouldSkip
                    ? Object.create(null)
                    : mapPropsToOptions(props);
                if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                    opts.variables = calculateVariablesFromProps(operation, props);
                }
                return (react.createElement(Subscription/* Subscription */.w, (0,tslib_es6/* __assign */.pi)({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, subscription: document, shouldResubscribe: this.state.resubscribe }), function (_a) {
                    var _b, _c;
                    var data = _a.data, r = (0,tslib_es6/* __rest */._T)(_a, ["data"]);
                    if (operationOptions.withRef) {
                        _this.withRef = true;
                        props = Object.assign({}, props, {
                            ref: _this.setWrappedInstance
                        });
                    }
                    if (shouldSkip) {
                        return (react.createElement(WrappedComponent, (0,tslib_es6/* __assign */.pi)({}, props, {})));
                    }
                    var result = Object.assign(r, data || {});
                    var name = operationOptions.name || 'data';
                    var childProps = (_b = {}, _b[name] = result, _b);
                    if (operationOptions.props) {
                        var newResult = (_c = {},
                            _c[name] = result,
                            _c.ownProps = props,
                            _c);
                        lastResultProps = operationOptions.props(newResult, lastResultProps);
                        childProps = lastResultProps;
                    }
                    return (react.createElement(WrappedComponent, (0,tslib_es6/* __assign */.pi)({}, props, childProps)));
                }));
            };
            GraphQL.displayName = graphQLDisplayName;
            GraphQL.WrappedComponent = WrappedComponent;
            return GraphQL;
        }(GraphQLBase));
        return hoist_non_react_statics_cjs(GraphQL, WrappedComponent, {});
    };
}
//# sourceMappingURL=subscription-hoc.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hoc/graphql.js




function graphql(document, operationOptions) {
    if (operationOptions === void 0) { operationOptions = {}; }
    switch ((0,parser/* parser */.E2)(document).type) {
        case parser/* DocumentType.Mutation */.n_.Mutation:
            return withMutation(document, operationOptions);
        case parser/* DocumentType.Subscription */.n_.Subscription:
            return withSubscription(document, operationOptions);
        case parser/* DocumentType.Query */.n_.Query:
        default:
            return withQuery(document, operationOptions);
    }
}
//# sourceMappingURL=graphql.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloConsumer.js
var ApolloConsumer = __webpack_require__(86735);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hoc/withApollo.js





function withApollo_getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
function withApollo(WrappedComponent, operationOptions) {
    if (operationOptions === void 0) { operationOptions = {}; }
    var withDisplayName = "withApollo(".concat(withApollo_getDisplayName(WrappedComponent), ")");
    var WithApollo = (function (_super) {
        (0,tslib_es6/* __extends */.ZT)(WithApollo, _super);
        function WithApollo(props) {
            var _this = _super.call(this, props) || this;
            _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
            return _this;
        }
        WithApollo.prototype.getWrappedInstance = function () {
            __DEV__ ? (0,globals/* invariant */.kG)(operationOptions.withRef, "To access the wrapped instance, you need to specify " +
                "{ withRef: true } in the options") : (0,globals/* invariant */.kG)(operationOptions.withRef, 28);
            return this.wrappedInstance;
        };
        WithApollo.prototype.setWrappedInstance = function (ref) {
            this.wrappedInstance = ref;
        };
        WithApollo.prototype.render = function () {
            var _this = this;
            return (react.createElement(ApolloConsumer/* ApolloConsumer */.a, null, function (client) {
                var props = Object.assign({}, _this.props, {
                    client: client,
                    ref: operationOptions.withRef
                        ? _this.setWrappedInstance
                        : undefined
                });
                return react.createElement(WrappedComponent, (0,tslib_es6/* __assign */.pi)({}, props));
            }));
        };
        WithApollo.displayName = withDisplayName;
        WithApollo.WrappedComponent = WrappedComponent;
        return WithApollo;
    }(react.Component));
    return hoist_non_react_statics_cjs(WithApollo, WrappedComponent, {});
}
//# sourceMappingURL=withApollo.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hoc/index.js







//# sourceMappingURL=index.js.map

/***/ })

}]);